import apiClient from '../clienteFebosAPI';

const RESOURCE = '/v2/herramientas';

export const getFileByQr = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/validacion/qr/expediente?${params}`, {
    operacionId: 'io.get.file.v2'
  });
};

export const getConfigurationParameters = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/configuraciones?${params}`, {
    operacionId: 'io.get.configuratons.v2'
  });
};

export const initProcessFromId = ({ id, payload }) => {
  const params = apiClient.queryParams({ id });
  return apiClient.post(`${RESOURCE}/procesos/${id}/iniciar?${params}`,
    payload,
    {
      operacionId: 'io.tools.process.init',
    });
};
